export default __webpack_public_path__ + "static/media/link output.cdea315f.svg";